import classNames from 'classnames';
import React from 'react';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import style from './TextLengthCounter.scss';

type Props = {
  length?: number;
  maxLength?: number;
  containerStyle?: string;
};

export const TextLengthCounter: React.FC<Props> = ({ length = 0, maxLength = 0, containerStyle }) => {
  return maxLength ? (
    <div className={classNames(style.container, containerStyle)}>
      <Text variant="sm" color={Color.GRAY}>
        {length}/{maxLength}
      </Text>
    </div>
  ) : null;
};
